<header>
  <div id="filters">
    @if (taxYearOptions) {
    <app-search-dropdown
      label="Select {{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    } @if (taxReturnTypeOptions) {
    <app-search-dropdown
      label="Select {{ taxReturnAlias }} Type"
      [formGroup]="searchForm"
      [formCtrl]="taxReturnType"
      [listOptions]="taxReturnTypeOptions"
    ></app-search-dropdown>
    }
    <div
      id="go"
      [routerLink]="['/settings', 'form', 'builder']"
      [queryParams]="{
        tab: 'categories',
        taxYear: taxYear?.value?.value,
        taxReturnTypeId: taxReturnType?.value?.value
      }"
      class="ui primary background button"
    >
      {{ "settings.go" | transloco }}
    </div>
  </div>
</header>
